import { required, maxLength, minLength, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default {
  form: {
    fullname: {
      required: helpers.withMessage(i18n.global.t('Please enter a supplier name.'), required),
      maxLength: helpers.withMessage(
        ({
          $params,
        }) => i18n.global.t('Supplier name cannot exceed') +  ' ' + $params.max + ' ' + i18n.global.t('characters.'),
        maxLength(255)
      ),
      minLength: helpers.withMessage(
        ({
          $params,
        }) => i18n.global.t('Supplier name must be at least') +  ' ' + $params.min + ' ' + i18n.global.t('characters long.'),
        minLength(3)
      ),
      pattern: helpers.withMessage(i18n.global.t('Supplier names can include Thai, English, and numeric characters, as well as certain special characters.'), helpers.regex(/^[A-Zก-๙a-z0-9-_/& ]+$/)),
    },
    tax_policy: {
      required: helpers.withMessage(i18n.global.t('Please enter.'), required)
    },
    tax_id: {
      pattern: helpers.withMessage(i18n.global.t('Tax ID must be 13 digits.'), helpers.regex(/^\d{13}$/)),
    },
    email: {

    },
    telephone1: {

    },
    telephone2: {

    },
    branch: {
      required: helpers.withMessage(i18n.global.t('Please enter a branch.'), required),
      maxLength: helpers.withMessage(
        ({
          $params,
        }) => i18n.global.t('Supplier branch cannot exceed') +  ' ' + $params.max + ' ' + i18n.global.t('characters.'),
        maxLength(255)
      ),
      pattern: helpers.withMessage(i18n.global.t('Supplier branchs can include Thai, English, and numeric characters, as well as certain special characters.'), helpers.regex(/^[A-Zก-๙a-z0-9-_/& ]+$/)),
    },
    address: {},
    postal_code: {},
    sub_district: {},
    district: {},
    province: {}
  }
};
